export const calculateViewportUnits = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`)
}

export const calculateHeaderSize = () => {
    const header = document.querySelector('.js-page-header')

    if (!header) {
        return
    }

    document.documentElement.dataset.headerHeight = header.offsetHeight
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`)

    const main = header.querySelector('.js-header-main')
    const scrollAway = main
        ? Math.max(0, Math.round(main.getBoundingClientRect().top - header.getBoundingClientRect().top))
        : 0

    document.documentElement.style.setProperty('--header-scroll-away', `${scrollAway}px`)
    document.documentElement.style.setProperty('--header-pinned-height', `${header.offsetHeight - scrollAway}px`)

    calculateHeaderVisibleHeight()
}

export const calculateHeaderVisibleHeight = () => {
    const header = document.querySelector('.js-page-header')

    if (!header) {
        return
    }

    const visibleHeight = Math.max(0, Math.round(header.getBoundingClientRect().bottom))

    document.documentElement.style.setProperty('--header-visible-height', `${visibleHeight}px`)
}
